type WrapperGeneralProps = {
	children: React.ReactNode;
};

export default function WrapperGeneral({ children }: WrapperGeneralProps) {
	return <div className="wrapper-general">{children}</div>;
}
